module.exports = __webpack_public_path__ + "static/media/mira_search_t_header.ef90f054.png";